export class StringService {
    byteChunk(str, byteLength, offset = null) {
        const chars = Array.from(str);
        const chunks = [''];
        let currentChunkSize = 0;
        let chunkIndex = 0;
        const offsetChars = [' ', '\r', '\n', '\t', '.'];
        let lastSeparator = -1;
        chars.forEach((charString) => {
            const length = (new TextEncoder().encode(charString)).length;
            if (offset !== null) {
                if (offsetChars.indexOf(charString) > -1) {
                    lastSeparator = currentChunkSize + 1;
                }
            }
            if (currentChunkSize + length > byteLength) {
                let appendNewChunk = true;
                if (lastSeparator > -1) {
                    if (currentChunkSize - lastSeparator <= offset
                        && chunks.length >= 1) {
                        chunks.push(chunks[chunkIndex].substr(lastSeparator).trim());
                        chunks[chunkIndex] = chunks[chunkIndex].substr(0, lastSeparator).trim();
                        appendNewChunk = false;
                        currentChunkSize -= lastSeparator;
                        chunkIndex++;
                        lastSeparator = -1;
                    }
                }
                if (appendNewChunk) {
                    chunkIndex++;
                    currentChunkSize = 0;
                    chunks.push('');
                }
            }
            chunks[chunkIndex] = (chunks[chunkIndex] + charString);
            currentChunkSize += length;
        });
        return chunks;
    }
}
